import { defineMessages } from 'react-intl';

export default defineMessages({
  addGlobalConversation: {
    id: 'frontbucket.repository.pullRequestConversation.addGlobalConversation',
    description:
      'Placeholder text in global comments section under the Activity header on a pull request page',
    defaultMessage: 'What do you want to say?',
  },
  loginLinkTextGlobalConversation: {
    id: 'frontbucket.repository.pullRequestConversation.loginLinkTextGlobalConversation',
    description: 'Text for link to log in page',
    defaultMessage: 'Log in to add a comment',
  },
});
